/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20.058 20.393a5 5 0 11-2.719 2.8l-5.762-3.704a5 5 0 110-6.978l5.762-3.704a4.994 4.994 0 111.084 1.681l-5.762 3.705a4.98 4.98 0 010 3.614l5.762 3.705a4.984 4.984 0 011.635-1.119z" _fill="#0B2C62"/>'
  }
})
